import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ResourceType } from "@/types/resource";
import { Search } from "lucide-react";
import { Database } from "@/integrations/supabase/types";

type DonationResourceType = Database['public']['Enums']['donation_resource_type'];

interface FilterSectionProps {
  selectedTypes: ResourceType[] | DonationResourceType[];
  setSelectedTypes: (types: ResourceType[] | DonationResourceType[]) => void;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  mode: "receive" | "donate";
}

const FilterSection = ({
  selectedTypes,
  setSelectedTypes,
  searchQuery,
  setSearchQuery,
  mode,
}: FilterSectionProps) => {
  const receiveResourceTypes: ResourceType[] = ['shelter', 'food', 'grants', 'loans', 'medical', 'supplies', 'transportation', 'pets', 'storage', 'admin_support', 'first_responders', 'other'];
  const donateResourceTypes: DonationResourceType[] = ['volunteer', 'donate', 'buy', 'gofundme', 'equipment'];

  const toggleType = (type: ResourceType | DonationResourceType) => {
    if (mode === "receive") {
      const currentTypes = selectedTypes as ResourceType[];
      const newTypes = currentTypes.includes(type as ResourceType)
        ? currentTypes.filter(t => t !== type)
        : [...currentTypes, type as ResourceType];
      setSelectedTypes(newTypes);
    } else {
      const currentTypes = selectedTypes as DonationResourceType[];
      const newTypes = currentTypes.includes(type as DonationResourceType)
        ? currentTypes.filter(t => t !== type)
        : [...currentTypes, type as DonationResourceType];
      setSelectedTypes(newTypes);
    }
  };

  return (
    <div className="w-full max-w-3xl mx-auto p-4 space-y-4">
      <div className="relative">
        <Input
          type="text"
          placeholder={mode === "receive" ? "Search for resources..." : "Search for donation opportunities..."}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="pl-10"
        />
        <Search className="absolute left-3 top-2.5 h-5 w-5 text-muted-foreground" />
      </div>
      {mode === "receive" && (
        <div className="flex flex-wrap gap-2">
          {receiveResourceTypes.map((type) => (
            <Button
              key={type}
              variant={selectedTypes.includes(type as never) ? "default" : "outline"}
              onClick={() => toggleType(type)}
              className="capitalize"
            >
              {type.replace('_', ' ')}
            </Button>
          ))}
        </div>
      )}
      {mode === "donate" && (
        <div className="flex flex-wrap gap-2">
          {donateResourceTypes.map((type) => (
            <Button
              key={type}
              variant={selectedTypes.includes(type as never) ? "default" : "outline"}
              onClick={() => toggleType(type)}
              className="capitalize"
            >
              {type}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
};

export default FilterSection;